import React from 'react';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { IGenerateAccessCodesJobDetails, IGenerateAccessCodesJobResult } from '../../../api/jobs.dao';

const generateAccessCodesJobProperties:
    IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IGenerateAccessCodesJobDetails, IGenerateAccessCodesJobResult>> = {
    reviewCompletedJobButtonText: 'Ok',
    reviewFailedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IGenerateAccessCodesJobDetails, IGenerateAccessCodesJobResult>) => {

        const {generatedAccessCodes, couldNotBeGeneratedCodes} = props.result;
        const {eventName} = props.jobDetails;

        return (
            <div className='alert-content'>
                <div className='alert-content__item'>{generatedAccessCodes} codes have been successfully generated for {eventName}.</div>
                <div className='alert-content__item' >{couldNotBeGeneratedCodes} codes could not be generated.</div>
            </div>
        );
    },
    failedComponent: () => {
        return <>Generation of access codes has failed</>;
    }
};

export { generateAccessCodesJobProperties };
